var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","lang":this.$i18n.locale}},[_c('router-view'),_c('alert-modal'),_c('confirm-modal'),_c('data-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }